<div class="global-overlay-page">

  <div style="display: flex; justify-content: center;padding:20px;">


    <div style="width:100%;">

      @if (showTip) {
      <div class="tip">
        <div style="position:absolute; right:10px; bottom: 5px;">
          <a (click)="hideTip()"> Thanks, I got this!</a>
        </div>
        <p>Content items are shared by any code that uses it. That is, if you edit the spreadsheet
          and click update, any code that uses that content will be updated with your change. </p>
        <p>If you want unique content for a code, you must copy the spreadsheet and then click New Content. Be sure to
          update the sheet's metadata.property.name to be unique.
        </p>
      </div>
      }

      @if (clientId > 0 && code) {
      <div class="title">
        <div>{{code.code}} - {{code.description}}</div>
        @if (clientId > 0) {
        <div>{{clientName}}</div>
        }
      </div>
      }

      <div class="filter-row">


        <div style="display: flex;margin-top:20px;align-items:center;">
          <input type="text" (keyup)="filter($event)" placeholder="Filter content" [value]="contentFilter" />


          <div class="toolbar" style="margin-left:20px;">
            <a (click)="newContent()">New Content</a>
            <a (click)="goToGlobalSearch()">Global S&R</a>
            <a [routerLink]="['/content-editor']">Builder</a>
            <a [routerLink]="['/mass-section']">Global Section</a>
            <a [routerLink]="['/manage-videos']">Videos</a>
          </div>

          @if (code && code.use_stencil_id == null) {
          <div style="margin-left:20px;line-height:2.5rem;">
            <mat-checkbox (change)="toggleStencil($event)" [checked]="!!code.stencil">Save as template</mat-checkbox>
          </div>
          }

          @if (code && code.stencil == false && code.use_stencil_id) {
          <div style="margin-left:20px;line-height:2.5rem;">
            <label style="margin-right:10px;">{{code.use_stencil_id != null ? "Using" : "Use" }} template </label>
            <select (change)="useTemplate($event)" [disabled]="true" style="padding:7px;">
              @for (item of stencils; track item) {
              <option [value]="item.id" [selected]="item.id == code.use_stencil_id">
                {{item.description}}</option>
              }
            </select>
          </div>
          }
        </div>
      </div>

      <mat-table #table [dataSource]="dataSource" matSort>


        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Include</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [disabled]="code && code.use_stencil_id != null"
              (change)="toggleIncludeContent($event, element)"
              [checked]="element.active"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef>ID</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.hcontent_id}}</mat-cell>
        </ng-container>



        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
          <mat-cell *matCellDef="let element"><span>{{element.type}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="version">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.version}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="publish">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            @if (element.unpublished) {
              <button class="publish-btn"
                [class.state-loading]="publishState.get(element.hcontent_id) === 'loading'"
                [class.state-success]="publishState.get(element.hcontent_id) === 'success'"
                [class.state-error]="publishState.get(element.hcontent_id) === 'error'"
                [disabled]="publishState.get(element.hcontent_id) === 'loading' || publishState.get(element.hcontent_id) === 'success'"
                (click)="publishContent(element)">
                @if (publishState.get(element.hcontent_id) === 'loading') {
                  <span class="publish-spinner"></span>
                } @else if (publishState.get(element.hcontent_id) === 'success') {
                  <mat-icon class="publish-icon">check</mat-icon>
                } @else if (publishState.get(element.hcontent_id) === 'error') {
                  <mat-icon class="publish-icon">close</mat-icon>
                }
                {{ publishState.get(element.hcontent_id) === 'success' ? 'Published!' : 'Publish' }}
              </button>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="action-container" (mouseleave)="onMouseLeave()"
              (mouseenter)="onMouseEnter(element.hcontent_id)">
              <a class="menu-trigger" (click)="toggleMenu(element.hcontent_id, $event)"
                [class.active]="activeMenuId === element.hcontent_id">
                <mat-icon>more_vert</mat-icon>
              </a>
              <div class="row-toolbar" [class.visible]="activeMenuId === element.hcontent_id">
                <a *ngIf="!element.google_doc_id.includes(':')" class="action-btn" (click)="openSpreadsheet(element.google_doc_id)">Spreadsheet</a>
                <a *ngIf="!element.google_doc_id.includes(':')" class="action-btn" (click)="preview(element.google_doc_id)">Preview</a>
                <a class="action-btn" (click)="currentPreview(element.hcontent_id)">{{ element.google_doc_id.includes(':') ? 'Preview' : 'Production'}}</a>
                <a *ngIf="!element.google_doc_id.includes(':')" class="action-btn" (click)="updateContent(element.hcontent_id)">Update</a>
                <a class="action-btn" [routerLink]="['/content-editor', element.hcontent_id]" title="Build">Builder </a>

              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ts">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Timestamp</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.ts}}</mat-cell>
        </ng-container>


        <ng-container matColumnDef="code_count">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Count</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.code_count}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="duration">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Duration</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ element.duration != null ? (element.duration + ' min') : '—' }}</span>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row [ngClass]="{'active-row': row.active}" *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      @if (loading) {
      <div class="skeleton-container">
        @for (row of skeletonRows; track $index) {
        <div class="skeleton-row-flex">
          @for (weight of row; track $index) {
          <div class="skeleton-bar" [style.flex-grow]="weight"></div>
          }
        </div>
        }
      </div>
      }

      <div style="display: flex; justify-content: center; align-items: center; gap: 15px;">
        <div style="display: flex; align-items: center;">
          <label style="margin-right: 10px;">Items per page</label>
          <select (change)="onPageSizeChange($event)" [value]="pageSize" style="padding:7px;">
            @for (size of pageSizeOptions; track size) {
            <option [value]="size">{{size}}</option>
            }
          </select>
        </div>
        <mat-paginator [length]="contents.length" [pageSize]="pageSize" showFirstLastButtons hidePageSize="true">
        </mat-paginator>
      </div>

    </div>


  </div>



  @if (content) {
  <div class="modal-overlay">
    <div class="modal-content-wrapper">
      <app-content-detail (close)="closeNewContent($event)"></app-content-detail>
    </div>
  </div>
  }


  <div style="float:right;font-size:0.5em;">
    <a target="_blank" href="https://icons8.com/icon/111783/file-preview">preview</a> icon by <a target="_blank"
      href="https://icons8.com">Icons8</a>
  </div>
</div>
